// extracted by mini-css-extract-plugin
module.exports = {"ScrollArea":"ScrollArea_ScrollArea__23Xwc","horizontal":"ScrollArea_horizontal__2WSwp","vertical":"ScrollArea_vertical__20_N9","hideScrollbar":"ScrollArea_hideScrollbar__9KVsj"};